import { Link } from "react-router-dom";

import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import { isPositiveNumber } from "et3-type-guards";
import getCorePersonalStore from "../../stores/core/core-personal-store";

const HeaderMenuItem = withLiteObserverAndTheme<{
  text: string;
  counter: string;
  link: string;
  enabled: boolean;
  size: "SMALL" | "MEDIUM" | "BIG";
  isSelected: boolean;
}>((props) => {
  const { theme, text, counter, link, enabled, size, isSelected } = props;
  const { colors, unitX } = theme;
  const parseCounter = parseInt(counter, 10);
  const isAlarms = isPositiveNumber(parseCounter) && text === "Alarms";
  const isKhattabatResults = text === "Results 101M";
  const finalizedWidth = size === "SMALL" ? 200 : size === "MEDIUM" ? 300 : 415;
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()
  const shouldHideCounter = isKhattabatResults || isAiKhattaba




  return (
    <Link
      to={link}
      id="menu-item"
      style={{
        textDecoration: "none",
        boxShadow: "none",
        backgroundColor: colors.all.transparent,
        border: "0px"
      }}
      onClick={(event) => {
        if (!enabled) event.preventDefault();
      }}
      aria-disabled={!enabled}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={finalizedWidth}
        height={95}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => { }}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={25}
          text={text}
          isSpan={false}
          color={
            isAlarms
              ? colors.all.red
              : isSelected
                ? colors.all.bondiBlue
                : enabled
                  ? colors.all.maastrichtBlue
                  : colors.all.dimGray
          }
          style={{
            border: isAlarms ? `solid ${colors.all.red}` : "none",
            borderWidth: isAlarms ? 2 * unitX : 0,
            borderRadius: isAlarms ? 20 : 0,
            padding: 5 * unitX
          }}
        />
        <Et3Margin top={0} right={0} left={5} bottom={0} />
        {shouldHideCounter ? null : (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={50}
            height={25}
            fDirection="row"
            alignItems="center"
            justifyContent="center"
            color={colors.all.red}
            style={{
              borderRadius: 20
            }}
            onClick={() => { }}
          >
            <Et3Text
              fontFamily={"BOLD"}
              fontSize={12}
              text={counter}
              isSpan={false}
              color={colors.all.white}
              style={{}}
            />
          </ET3Div>
        )}
      </ET3Div>
    </Link>
  );
});

export default HeaderMenuItem;
